import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const EditReview = () => {
  const { review_id } = useParams(); // Get the review ID from the URL
  const [updatedReview, setUpdatedReview] = useState(''); // Initialize with an empty string
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const textareaRef = useRef(null); // Reference to the textarea element


  
  useEffect(() => {
    const fetchReview = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/reviews/${review_id}`);
        setUpdatedReview(response.data.review); // Pre-fill the textarea with the existing review
      } catch (err) {
        console.error('Error fetching feedback:', err);
        setError('Failed to fetch the feedback.');
      }
    };
    fetchReview();
  }, [review_id]);

  useEffect(() => {
    // Adjust the height of the textarea to fit its content
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // Reset height to auto to calculate the correct height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height to fit content
    }
  }, [updatedReview]); // Run this effect whenever `updatedReview` changes



  const handleEdit = async () => {
    // Calculate the word count of the updated review
    const wordCount = updatedReview.trim().split(/\s+/).length;
  
    // Check if the word count is less than 200
    if (wordCount < 200) {
      setError('Your feedback must be at least 200 words.');
      setSuccess('');
      return; // Stop further execution if the word count is insufficient
    }
  
    try {
      const reviewerId = localStorage.getItem('user_id'); // Get the logged-in user's ID
      const response = await axios.patch(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/reviews/${review_id}`, {
        reviewer_id: reviewerId,
        updated_review: updatedReview,
      });
      setSuccess(response.data.message);
      setError('');
      setTimeout(() => navigate('/my-reviews'), 2000); // Redirect to "My Reviews" after success
    } catch (err) {
      console.error('Error updating feedback:', err);
      setError(err.response?.data?.error || 'Failed to update feedback.');
      setSuccess('');
    }
  };


  return (
    <div
      style={{
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        backgroundColor: '#f9f9f9', // Soft light gray background
        minHeight: '100vh', // Full viewport height
      }}
    >
      <h1 style={{ textAlign: 'center', color: '#0056b3', marginBottom: '20px' }}>
        Edit Feedback
      </h1>
      {error && (
        <p style={{ color: '#dc3545', textAlign: 'center', fontWeight: 'bold', marginBottom: '20px' }}>
          {error}
        </p>
      )}
      {success && (
        <p style={{ color: '#28a745', textAlign: 'center', fontWeight: 'bold', marginBottom: '20px' }}>
          {success}
        </p>
      )}
     <textarea
        ref={textareaRef} // Attach the ref to the textarea
        value={updatedReview}
        onChange={(e) => setUpdatedReview(e.target.value)}
        rows="5"
        cols="50"
        placeholder="Edit your feedback here..."
        style={{
          width: '98%',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '5px',
          fontSize: '16px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          marginBottom: '20px',
          resize: 'none', // Prevent manual resizing
          overflow: 'hidden', // Hide scrollbars
        }}
      />
      <div
        style={{
          textAlign: 'right',
          fontSize: '14px',
          color: updatedReview.trim().split(/\s+/).length < 200 ? '#dc3545' : '#28a745', // Red if less than 200 words, green otherwise
          marginBottom: '10px',
        }}
      >
        Word Count: {updatedReview.trim().split(/\s+/).filter((word) => word).length} / 200
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
        <button
          onClick={handleEdit}
          style={{
            padding: '10px 20px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#218838')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#28a745')}
        >
          Save Changes
        </button>
        <button
          onClick={() => navigate('/my-reviews')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#c82333')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#dc3545')}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EditReview;